import React, { useState, useEffect } from "react";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import { BottomSectionModal } from "../../../constants/assets/containers";
import { connect } from "react-redux";
import NoFooterModal from "../../Common/NoFooterModal";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import SuccessMessages from "../../../constants/SucessMessages.json";
import {
  isValidated,
  isValNull,
  filterObj,
  getInitialState,
} from "../../../utils";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import MenuItem from "sushiweb/MenuItem";
import Searchbox from "sushiweb/Searchbox";
import * as DriverSheltersActions from "../../../store/actions/DriverShelters";
import { bindActionCreators } from "redux";
import { setStatus } from "../../../store/actions/User";

const enableOptions = [
  { key: true, label: "True" },
  { key: false, label: "False" },
];

const mandatoryFields = [
  "name",
  "address",
  "latitude",
  "longitude",
  "is_active",
  "is_rest_point",
  "open_timings",
];

const editableFields = [
  "name",
  "address",
  "amenities",
  "latitude",
  "longitude",
  "is_active",
  "is_rest_point",
  "open_timings",
];

const ShelterFormModal = (props) => {
  const allActions = MenuActionsMappings[MenuNames.DRIVER_SHELTER];
  const [initialState, setInitialState] = useState({
    name: "",
    address: "",
    latitude: "",
    longitude: "",
    is_active: "",
    is_rest_point: "",
    open_timings: "",
    amenities: [],
  });
  const {
    modalState,
    activeId,
    activeDriverShelter,
    currentPage,
    handleClose,
    setStatus,
    getShelter,
    createDriverShelter,
  } = props;
  const amenitiesData = [
    { id: 1, name: "Water" },
    { id: 2, name: "Phone Charge" },
    { id: 3, name: "Wifi" },
    { id: 4, name: "Toilet" },
    { id: 5, name: "First Aid" },
  ];

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const getRequiredButtonPerms = (action = undefined) => {
    if (modalState === "Edit") {
      return [allActions.UPDATE];
    }
    if (modalState === "Add") {
      return [allActions.CREATE];
    }
    return undefined;
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const clearFilters = () => {
    setInitialState({
      name: "",
      address: "",
      latitude: "",
      longitude: "",
      is_active: "",
      open_timings: "",
      amenities: [],
    });
  };
  const handleSubmit = (evt) => {
    evt.preventDefault();

    if (modalState === "Edit") {
      const updatedEditableFields = [...editableFields];
      const body = filterObj(initialState, updatedEditableFields);
      props.updateShelter(activeId, body).then((res) => {
        const pageRequest = { page: currentPage };
        props.getShelterList({}, pageRequest);
      });
    } else if (modalState === "Add") {
      const body = filterObj(initialState, [
        "name",
        "address",
        "latitude",
        "longitude",
        "is_active",
        "is_rest_point",
        "open_timings",
        "amenities",
      ]);

      let validatedState = isValidated(body, mandatoryFields);
      if (validatedState === "validated") {
        props.createDriverShelter(body).then((res) => {
          const pageRequest = { page: currentPage };
          props.getShelterList({}, pageRequest);
          setStatus({
            type: "success",
            message: SuccessMessages.CREATION_SUCCESS,
          });
          clearFilters();
        });
      } else {
        setStatus({ type: "error", message: validatedState });
      }
    }
  };

  const handleSelect = (key, val) => {
    console.log(key, val);
    const values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const getModalButtons = () => {
    return (
      <BottomSectionModal className="flex items-center justify-between">
        <Permission requiredPerms={getRequiredButtonPerms()}>
          <Button
            data-testid="submitDriverShelterButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </Permission>
      </BottomSectionModal>
    );
  };

  useEffect(() => {
    // update the initialState on modal render.
    // this is not needed when modalState is "Add".
    if (
      modalState === "Edit" &&
      Object.keys(activeDriverShelter).length === 0
    ) {
      getShelter(activeId);
    }

    if (modalState === "Edit" && Object.keys(activeDriverShelter).length > 0) {
      const values = { ...initialState };
      Object.keys(values).forEach((key) => {
        values[key] = !isValNull(activeDriverShelter[key])
          ? activeDriverShelter[key]
          : getInitialState(initialState, key);
      });
      if (!isValNull(values["latitude"])) {
        values["latitude"] = values["latitude"] + "";
      }
      if (!isValNull(values["longitude"])) {
        values["longitude"] = values["longitude"] + "";
      }
      setInitialState(values);
    }
  }, [activeDriverShelter]);

  return (
    <NoFooterModal
      header={true}
      heading={`${modalState} Driver Shelter`}
      handleClose={handleClose}
      id="DriverShelterModal"
      modalButtons={getModalButtons()}
    >
      <Input
        value={initialState.name}
        data-testid="name"
        id="sushi-input"
        onChange={(e) => handleChange("name", e)}
        label="Name"
      />
      <Input
        value={initialState.address}
        data-testid="address"
        id="sushi-input"
        onChange={(e) => handleChange("address", e)}
        label="Address"
      />
      <Input
        type={"number"}
        value={initialState.latitude}
        data-testid="latitude"
        id="sushi-input"
        onChange={(e) => handleChange("latitude", e)}
        label="Latitude"
      />
      <Input
        type={"number"}
        value={initialState.longitude}
        data-testid="longitude"
        id="sushi-input"
        onChange={(e) => handleChange("longitude", e)}
        label="Longitude"
      />

      <PaginatedReactDropdown
        options={enableOptions}
        data-testid="isActive"
        labelKey="label"
        valueKey="key"
        value={getInputLabel(
          initialState.is_active,
          enableOptions,
          "key",
          "label"
        )}
        labelWidth="20%"
        handleChange={handleChange}
        keyToChange="is_active"
        placeholder="Is active"
        showCross={true}
        id="isActive"
      />

      <PaginatedReactDropdown
        options={enableOptions}
        data-testid="isRestPoint"
        labelKey="label"
        valueKey="key"
        value={getInputLabel(
          initialState.is_rest_point,
          enableOptions,
          "key",
          "label"
        )}
        labelWidth="20%"
        handleChange={handleChange}
        keyToChange="is_rest_point"
        placeholder="Priority"
        showCross={true}
        id="isRestPoint"
      />

      <div onSubmit="return false;" className="mb-20" id="add-roles">
        <Searchbox
          placeholder="Select Amenities"
          className="sushi-searchbox"
          tagType="red"
          helperText=""
          type="tag"
          onChange={handleChange}
          onSelect={(e) => handleSelect("amenities", e)}
          showDropdownArrow={false}
        >
          {amenitiesData.map((role, index) => {
            return (
              <MenuItem
                key={"roles" + index}
                value={role.id}
                label={role.name}
              />
            );
          })}
        </Searchbox>
      </div>

      <Input
        value={initialState.open_timings}
        data-testid="open_timings"
        id="sushi-input"
        onChange={(e) => handleChange("open_timings", e)}
        label="Open Timings"
      />
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  console.log(state);
  const { DriverShelters, State, MenuActions } = state;
  return {
    activeCity: DriverShelters.activeCity,
    activeFilters: DriverShelters.activeFilters,
    currentPage: DriverShelters.currentPage,
    nextPageState: State.nextPage,
    allMenuActions: MenuActions.allMenuActions,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    createDriverShelter: bindActionCreators(
      DriverSheltersActions.createDriverShelter,
      dispatch
    ),
    getShelterList: bindActionCreators(
      DriverSheltersActions.getDriverSheltersList,
      dispatch
    ),
    getShelter: bindActionCreators(
      DriverSheltersActions.getDriverShelter,
      dispatch
    ),
    updateShelter: bindActionCreators(
      DriverSheltersActions.updateDriverShelter,
      dispatch
    ),
    setStatus: bindActionCreators(setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShelterFormModal);
